"use client";

import * as React from "react";

type VTProps = { name: string; share?: string; children: React.ReactNode };

/**
 * Thin wrapper over React's experimental <ViewTransition> (enabled via
 * experimental.viewTransition). It's resolved defensively from the React
 * namespace so the app type-checks on stable React types and degrades to a
 * plain fragment if the component (or browser support) is unavailable —
 * navigation then just happens without the shared-element morph.
 */
const ReactNS = React as unknown as {
  ViewTransition?: React.ComponentType<VTProps>;
  unstable_ViewTransition?: React.ComponentType<VTProps>;
};
const ReactViewTransition = ReactNS.ViewTransition ?? ReactNS.unstable_ViewTransition;

export function ViewTransition({ name, share, children }: VTProps) {
  if (ReactViewTransition) {
    return (
      <ReactViewTransition name={name} share={share}>
        {children}
      </ReactViewTransition>
    );
  }
  return <>{children}</>;
}
